<template>
    <Modal
        :show="show"
        :closeable="closeable"
        @update:show="show => $emit('update:show', show)">
        <div class="px-4 py-6">
            <p v-if="message" v-html="message" class="mb-6 text-lg text-gray-700"/>
            <LoginForm
                ref="login"
                class="flex-1"
                @success="onSuccessfulLogin">
                <template v-slot="{form}">
                    <div class="mt-4 sm:flex sm:flex-row-reverse sm:items-center sm:mt-0">
                        <SubmitButton
                            class="w-full sm:w-auto sm:ml-4"
                            @click.prevent="$refs.login.submit()"
                            :submitting="form.processing"
                            :disabled="form.errors.any()">
                            Login
                        </SubmitButton>
                        <Button
                            v-if="closeable"
                            type="button"
                            theme="plain"
                            class="w-full mt-4 sm:w-auto sm:mt-0"
                            @click.prevent="close">
                            Cancel
                        </Button>

                        <router-link
                            :to="{name: 'password.request'}"
                            class="inline-block mt-4 underline text-sm text-gray-600 hover:text-gray-900 sm:mt-0 sm:mr-auto">
                            Forgot your password?
                        </router-link>
                    </div>
                </template>
            </LoginForm>
        </div>
    </Modal>
</template>

<script>

import Modal from "@/Components/Modal";
import Button from "@/Components/Button";
import LoginForm from "@/Components/Auth/LoginForm"
import SubmitButton from "@/Components/Form/SubmitButton";

export default {

    name: "LoginModal",

    props: {
        show: {
            default: false
        },
        closeable: {
            default: false
        },
        message: String
    },

    emits: [
        'update:show',
        'success'
    ],

    components: {
        Modal,
        Button,
        LoginForm,
        SubmitButton
    },

    methods: {
        close() {
            this.$emit('update:show', false);
        },
        onSuccessfulLogin() {
            this.$emit('success');
            this.close();
        }
    },

    watch: {
        '$route'() {
            if (this.closeable) {
                this.close();
            }
        }
    }
};

</script>
